import * as React from "react";
import { Checkbox, Radio } from "antd";
import { RightOutlined } from "@ant-design/icons";
import { BrowserDataItemProps } from "../types";
import styles from "../BrowserServiceModal.module.scss";

export const BrowserDataItem: React.FC<BrowserDataItemProps> = ({
  item,
  isActive,
  isSelected,
  isFocused,
  selectionType,
  canBeSelectedAsParent,
  canNavigateDeeper,
  onClick,
  onSelect,
}) => {
  const label = item._cpln.label;
  const hasChildren = !!item._cpln.hasChildren && canNavigateDeeper;

  // Determine if this item can be selected
  const canSelect = !hasChildren || canBeSelectedAsParent;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClick();
  };

  const handleSelect = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (canSelect) {
      onSelect();
    }
  };

  return (
    <div
      className={`${styles.dataItem} ${isActive ? styles.dataItemActive : ""} ${
        isFocused ? styles.dataItemFocused : ""
      }`}
      role="option"
      aria-selected={isSelected}
      data-browser-item
      onClick={handleClick}
    >
      {selectionType !== "none" && canSelect && (
        <span className={styles.dataItemCheckbox} onClick={handleSelect}>
          {selectionType === "multi" ? (
            <Checkbox checked={isSelected} tabIndex={-1} />
          ) : (
            <Radio checked={isSelected} tabIndex={-1} />
          )}
        </span>
      )}
      <span className={styles.dataItemLabel}>{label}</span>
      {hasChildren && (
        <span className={styles.dataItemArrow}>
          <RightOutlined style={{ fontSize: 12 }} />
        </span>
      )}
    </div>
  );
};
